import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorReducer from './errorReducer';

import imageReducer from './imageReducer';


import localizedMessageReducer from './localizedMessageReducer';
import productReducer from './productReducer';
import postalCodeReducer from './postalCodeReducer';
import userReducer from "./userReducer"
import pageReducer from './pageReducer';

export default combineReducers({
    auth: authReducer,
    errors: errorReducer,
    image: imageReducer,
    message: localizedMessageReducer,
    products: productReducer,
    postal: postalCodeReducer,
    user: userReducer,
    page: pageReducer
});